import React from "react"
import Router from "../routes/index"
import "./styles/extraStyles.css"
import "./styles/styles.css"
import Layout from "../pages/Layout"
import { HashRouter } from "react-router-dom"

// TODO: sidebar in inner table
// TODO: add refresh button to sale, stock, purchase
// TODO: refactor bindings

const App = () => {
  return (
    <HashRouter>
      <Layout>
        <Router />
      </Layout>
    </HashRouter>
  )
}

export default App
